export default __webpack_public_path__ + "static/media/hotspot-inner-yellow.26fd412d.svg";